import Cookies from 'js-cookie'

import * as types from '../mutation-types'
import { checkVariable, isObject } from '../../plugins/helper'

// state
export const state = {
  state_route: Cookies.get('state_route'),
  state_route_expired: Cookies.get('state_route_expired'),
}

// mutations
export const mutations = {
  [types.GET_STATE_ROUTE](state, payload) {
    if (isObject(payload)) {
      const {
        name,
        meta,
        path,
        hash,
        query,
        params,
        fullPath,
      } = payload
      const strPayload = JSON.stringify({ name, meta, path, hash, query, params, fullPath })
      state.state_route = strPayload
      Cookies.set('state_route', strPayload, { expires: 1 })
    }
  },

  [types.SET_STATE_ROUTE](state, payload) {
    if (checkVariable(payload)) {
      const strPayload = isObject(payload) ? JSON.stringify(payload) : payload
      state.state_route_expired = strPayload
      Cookies.set('state_route_expired', strPayload, { expires: 1 })
    }
  },
}

export const actions = {
  setStateRoute({ commit }, payload) {
    commit(types.GET_STATE_ROUTE, payload)
  },
  setLastRouteExpired({ commit }, payload) {
    commit(types.SET_STATE_ROUTE, payload)
  },
}

// getters
export const getters = {
  state_route: state => state.state_route,
  state_route_expired: state => state.state_route_expired,
}
